function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Product Template Scripts
 *    Scripts that are only meant to run on the Product Template.
 *
 *  Version:
 *    1.0.0 - 2020/03/03
 */

import { printMoney } from '@process-creative/slate-theme-tools';
import { Swatch, ON_VARIANT_CHANGE } from './../objects/swatch/Swatch';
import { artSwatches, SELECTOR_ART_SWATCHES_CONTAINER } from '../components/art-swatches/art-swatches';
import { ProductTemplateQuantitySelector } from './../objects/quantity/ProductTemplateQuantitySelector';
import { AddToCartButton } from './../objects/product/AddToCartButton';
import { Accordion, SLIDE_SELECTOR, EXPANDED_CLASS } from './../objects/content/Accordion';
import { backInStockForm } from './../objects/product/BackInStock';
import * as ResponsiveSizes from './../settings/Responsive';
import '../components/art-swatches/art-swatches';
import './../sections/product-ba/ProductBeforeAfter';
import './../sections/product-carousel/ProductCarousel';
import './../sections/product-features/ProductFeatures';
import './../sections/product-frame/ProductFrame';
import './../sections/product-how-to/ProductHowTo';
import './../sections/product-instagram/ProductInstagram';
import './../sections/product-recommendations/ProductRecommendations';
import './../sections/product-specs/ProductSpecs';
import './../sections/product-waitlist-notify/ProductWaitlistNotify';

//Selectors
export var PRODUCT_TEMPLATE_CONTAINER = '[data-product-template]';
export var PRODUCT_ADD = '[data-product-template-add-to-cart]';
export var PRODUCT_MONEY = '[data-product-money]';
export var PRODUCT_COMPARE_MONEY = '[data-product-compare-money]';
export var PRODUCT_ALTERNATE_PAYMENT_MONEY = '[data-alternate-money-price]';
export var PRODUCT_STICKY_TOP = '[data-product-sticky-top]';
export var HEADER_CONTAINER = '[data-header-container]';
export var FRAME_SCROLL = '[data-product-frame-scroll]';
export var FRAME_CONTAINER = '[data-product-frame]';
export var PRODUCT_DESCRIPTION_ACCORDIONS = '[data-product-description-accordions]';
export var PRODUCT_FAQ_ACCORDIONS = '[data-product-faq-accordions]';
var SELECTOR_ART_ADD_CONTAINER = '[data-art-add-btn-container]';
export var CLASS_VISIBLE = 'is-visible';
var CLASS_STUCK = 'is-stuck';
var CLASS_EXPANDED = 'is-expanded';
var ATTR_TEMPLATE = 'data-product-template';
var ProductTemplate = /*#__PURE__*/function () {
  function ProductTemplate(container) {
    var _this = this;
    _classCallCheck(this, ProductTemplate);
    //Elements
    this.container = container;
    this.templateType = container.attr(ATTR_TEMPLATE);
    this.productMoney = container.find(PRODUCT_MONEY);
    this.productCompare = container.find(PRODUCT_COMPARE_MONEY);
    this.alternatePaymentPrice = container.find(PRODUCT_ALTERNATE_PAYMENT_MONEY);
    this.header = $(HEADER_CONTAINER); //Outside of the container
    this.descriptionAccordionElement = $(PRODUCT_DESCRIPTION_ACCORDIONS);
    this.artAddBtnContainer = container[0].querySelector(SELECTOR_ART_ADD_CONTAINER);
    var artSwatchesModal = document.querySelector(SELECTOR_ART_SWATCHES_CONTAINER);
    this.faqAccordion = new Accordion($(PRODUCT_FAQ_ACCORDIONS));
    this.initDescriptionAccordion();

    //Setup Product Swatches Widget, Quantity and Add to cart
    this.swatches = new Swatch(this.container);
    this.quantitySelector = new ProductTemplateQuantitySelector(this, this.container);
    this.addToCart = new AddToCartButton(this, this.container.find(PRODUCT_ADD));
    if (artSwatchesModal) artSwatches(artSwatchesModal, container, this.swatches);
    container.on('click', PRODUCT_STICKY_TOP, function (e) {
      return _this.onBackToTop(e);
    });
    container.on('click', FRAME_SCROLL, function (e) {
      return _this.onFrameClick(e);
    });
    $(document).on(ON_VARIANT_CHANGE, function (e, variant) {
      return _this.onVariantChanged(variant);
    });

    //Sticky ATC Button
    if (this.artAddBtnContainer) {
      if (window.innerWidth >= ResponsiveSizes.medium) this.checkStickyState();
      window.addEventListener('resize', function () {
        return _this.checkTrackAnimationFrame();
      });
    }
  }
  _createClass(ProductTemplate, [{
    key: "initDescriptionAccordion",
    value: function initDescriptionAccordion() {
      //Add expanded class to the first level on desktop
      if ($(window).width() > ResponsiveSizes.medium) {
        this.descriptionAccordionElement.find(SLIDE_SELECTOR).first().addClass(CLASS_EXPANDED);
      }
      this.descriptionAccordion = new Accordion(this.descriptionAccordionElement);
    }
  }, {
    key: "onBackToTop",
    value: function onBackToTop(e) {
      e.preventDefault();
      e.stopPropagation();
      var headerHeight = this.header.outerHeight();
      $('html,body').animate({
        scrollTop: this.container.offset().top - headerHeight
      }, 'slow');
    }
  }, {
    key: "onFrameClick",
    value: function onFrameClick(e) {
      e.preventDefault();
      e.stopPropagation();
      var headerHeight = this.header.outerHeight();
      $('html,body').animate({
        scrollTop: $(FRAME_CONTAINER).offset().top - headerHeight
      }, 'slow');
    }
  }, {
    key: "onVariantChanged",
    value: function onVariantChanged(variant) {
      var price = variant.price,
        compare_at_price = variant.compare_at_price;

      //Adjust Price Display
      if (!price || price <= 0) {
        this.productMoney.removeAttr('data-money'); //Stops any currency converters attempting to convert.
        this.productMoney.html('FREE'); //TODO: Make this not hard coded.
      } else {
        this.productMoney.attr('data-money', price);
        this.productMoney.html(printMoney(price, 'money_with_currency_format').replace('.00', ''));
        this.alternatePaymentPrice.html(printMoney(price / 4, 'money_with_currency_format').replace('.00', ''));
      }

      //Adjust compare price display
      if (!this.productCompare) return;
      if (!compare_at_price || compare_at_price <= price) {
        this.productCompare.removeAttr('data-money');
        this.productCompare.html('');
      } else {
        this.productCompare.attr('data-money', compare_at_price);
        this.productCompare.html(printMoney(compare_at_price, 'money_with_currency_format').replace('.00', ''));
      }
    }
  }, {
    key: "checkTrackAnimationFrame",
    value: function checkTrackAnimationFrame() {
      if (!this.trackingAnimation && window.innerWidth >= ResponsiveSizes.medium) {
        this.checkStickyState();
      }
    }
  }, {
    key: "checkStickyState",
    value: function checkStickyState() {
      var _this2 = this;
      //Checks the add to cart container would be sticky and if so add a class.
      if (window.innerWidth < ResponsiveSizes.medium) {
        this.trackingAnimation = false;
        return;
      }
      this.trackingAnimation = true;
      var currentTop = document.documentElement.scrollTop;
      if (currentTop != this.lastPosition) {
        var element = this.artAddBtnContainer;
        var rect = element.getBoundingClientRect();
        if (window.innerHeight - rect.top - element.offsetHeight > 0) {
          element.classList.remove(CLASS_STUCK);
        } else {
          element.classList.add(CLASS_STUCK);
        }
        this.lastPosition = currentTop;
      }
      requestAnimationFrame(function () {
        return _this2.checkStickyState();
      });
    }
  }]);
  return ProductTemplate;
}();
$(document).ready($(PRODUCT_TEMPLATE_CONTAINER).each(function (e, i) {
  return new ProductTemplate($(i));
}));